<form nz-form [formGroup]="billingFilterForm">
    <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

        <div nz-col *ngIf="billingFilterForm.controls['module']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Module'">
                    <ppl-dropdown-select formControlName="module" class="filters" id="module"
                            [options]="moduleList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                            placeholder="Module" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['domain']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Domian'">
                    <ppl-dropdown-select formControlName="domain" class="filters" id="domain"
                            [options]="lookupDomainList" [optionLabel]="'lkp_domain_name'" [optionValue]="'lkp_domain_name'"
                            placeholder="Domain" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['lookupValue']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Lookup Value'">
                    <input placeholder="Lookup Value" nz-input (input)="onInput($event, 'lookupValue')" formControlName="lookupValue"
                        id="lookupValue" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['category']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please select a Category'">
                    <ppl-dropdown-select formControlName="category" class="filters" id="category"
                            [options]="categoryList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'"
                            placeholder="Category" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col *ngIf="billingFilterForm.controls['configKey']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
            [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <nz-form-control [nzErrorTip]="'Please enter Key'">
                    <input placeholder="Key" nz-input (input)="onInput($event, 'configKey')" formControlName="configKey"
                        id="configKey" />
                </nz-form-control>
            </nz-form-item>
        </div>

        <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
            style="text-align: right; margin-left: 8px; margin-right: 8px;">
            <nz-form-item>
                <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'ghost-button'"
                    [iconPosition]="'left'" (click)="search()"></ppl-button>
            </nz-form-item>
        </div>

    </div>
</form>